import { render, staticRenderFns } from "./weekly.vue?vue&type=template&id=d95cf25a&"
import script from "./weekly.vue?vue&type=script&lang=js&"
export * from "./weekly.vue?vue&type=script&lang=js&"
import style0 from "./weekly.vue?vue&type=style&index=0&id=d95cf25a&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports